import React, { useEffect, useRef, useState } from 'react';

// material-ui
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

// project imports

import ApsFolderMigrationContentDialog from '../../../components/autodesk/folderContentMigration';
import { useApsGetHubs, useApsGetProjects } from '../../../hooks/useAps';
import useMigrateStore from '../../../store/useMigrate';
import useConnectionStore from '../../../store/useConnectors';

const formData = [
  {
    value: 'detailpercent',
    label: 'PROGRESS DETAIL (%)'
  },
  {
    value: 'detail',
    label: 'PROGRESS DETAILS'
  },
  {
    value: 'uodate',
    label: 'PROGRESS UPDATE'
  },
  {
    value: 'projectinformation',
    label: 'PROJECT INFORMATION'
  }
];

export default function HubPage({ onConfirm }) {
  const payloadForm = useRef(null);
  const { provider, activeConnectionId, connectionOwnerName } = useConnectionStore((s) => s);
  const {
    setHubName,
    setOpenProject,
    openProject,
    setProjectName,
    projectName,
    toggleFolder,
    handleToggleFolder,
    handleChoosenFolderSource,
    handleChoosenFolderDestination,
    folderMode,
    handleSourceProviderData,
    handleDestinationProviderData
  } = useMigrateStore();

  const { data: dataHubs, isFetching: isLoadingHubs, isError: isErrorHubs } = useApsGetHubs();
  const [hubId, sethubId] = useState('');
  const { data: dataProjects, isFetching: isLoadingProjects, isError: isErrorProjects } = useApsGetProjects(hubId);

  const [openFolderDialog, setopenFolderDialog] = useState(false);
  const [showPanel, setshowPanel] = useState(false);

  useEffect(() => {
    return () => handleToggleFolder(false);
  }, []);

  const handleViewProjects = (data) => {
    setOpenProject(true);
    sethubId(data.id);
    setHubName(data.attributes?.name);
  };

  const handleMigrateData = ({ data, param }) => {
    const idProject = data?.relationships['issues'].data.id;
    const payload = {
      project_id: idProject,
      project_name: data.attributes.name,
      hub_id: hubId,
      connection_id: activeConnectionId,
      connection_owner_name: connectionOwnerName,
    };
    console.log({ data, payload });
    if (param === 'files') {
      // handleToggleFolder(true);
      // setshowPanel(true)
      setProjectName(data.attributes.name);
      setopenFolderDialog(true);
      payloadForm.current = payload;
    }
    if (param === 'form') {
    }

    // setOpen(false);
  };

  const handleCloseFolderContent = (data) => {
    setopenFolderDialog(false);
    setProjectName('');
    payloadForm.current = null;
  };

  const handleConfirmItemContent = ({data, breadcrumb, param}) => {
    setopenFolderDialog(false);
    if (!data) return false;
    console.log(data)
    const atributeName = data.type === "folders" ? data?.attributes.name: data?.attributes.displayName
    let payload = {
      type: data.type,
      provider: provider,
      connection_id: payloadForm.current.connection_id,
      connection_owner_name: payloadForm.current.connection_owner_name,
      data: data,
      // item_id: data.id,
      project_id: `b.${payloadForm.current.project_id}`,
      path_data: [...breadcrumb, {name: atributeName, id: data.id}]
    }
   
    if (folderMode == 'source') {
      payload = {
        ...payload,
        item_id: data.id
      }
      handleSourceProviderData(payload)
    }
    if (folderMode == 'destination') {
      payload = {
        ...payload,
        folder_id: data.id
      }
      handleDestinationProviderData(payload)
    }

    onConfirm({
      payload,
      param
    });
   
  };

  const [openFormModal, setopenFormModal] = useState(false);

  const handleOpenFormModal = () => {
    setopenFormModal(true);
  };

  const handleCloseFormModal = () => {
    setopenFormModal(false);
  };

  const closeFolder = () => {
    setshowPanel(false); // slide out first
  };

  const handleExited = () => {
    handleToggleFolder(false);
  };

  return (
    <Box mt={5} px={1}>
      <Grid container spacing={2} sx={{ position: 'relative' }}>
        {/* LEFT TABLE */}
        <Grid size={{ xs: 12, md: toggleFolder ? 7 : 12 }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: '35%' }}>
                    <strong>{openProject ? 'Project Name' : 'Hub Name'}</strong>
                  </TableCell>
                  <TableCell sx={{ width: '65%' }}>
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {!openProject &&
                  dataHubs?.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ width: '40%' }}>{row?.attributes?.name}</TableCell>

                      <TableCell sx={{ width: '60%' }}>
                        <Box>
                          <Button
                            sx={{ fontWeight: 'bold' }}
                            onClick={() => handleViewProjects(row)}
                            variant="outlined"
                            startIcon={<VisibilityOutlinedIcon />}
                          >
                            View Projects
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}

                {openProject &&
                  dataProjects?.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell>{row?.attributes?.name}</TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1}>
                          <Button
                            variant="outlined"
                            startIcon={<FolderOutlinedIcon />}
                            onClick={() => handleMigrateData({ data: row, param: 'files' })}
                          >
                            Select File
                          </Button>
                          <Button
                            variant="outlined"
                            startIcon={<AssignmentOutlinedIcon />}
                            onClick={() => handleMigrateData({ data: row, param: 'form' })}
                          >
                            Select Form
                          </Button>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      {openFolderDialog && (
        <ApsFolderMigrationContentDialog
          open={openFolderDialog}
          data={payloadForm.current}
          onClose={handleCloseFolderContent}
          onConfirm={(param) => handleConfirmItemContent(param)}
        />
      )}

      <Dialog open={openFormModal} onClose={handleCloseFormModal}>
        <DialogTitle>Select a Form</DialogTitle>
        <DialogContent>
          <DialogContentText>Available Form</DialogContentText>
          <Box sx={{ width: '25vw', mt: 3 }}>
            {/* <form onSubmit={handleSubmit} id="subscription-form"> */}
            <TextField
              fullWidth
              id="outlined-select-currency"
              select
              label="Select Type"
              defaultValue="all"
              // helperText="Please select your currency"
            >
              {formData.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
            {/* </form> */}
            <Button
              onClick={handleCloseFormModal}
              sx={{ mt: 3, fontWeight: 'bold' }}
              fullWidth
              variant="contained"
              form="subscription-form"
            >
              SUBMIT
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
